import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { common_axios } from "../../../../App";
import { toast, ToastContainer } from "react-toastify";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import PersonIcon from "@mui/icons-material/Person";
import Swal from "sweetalert2";
import DownloadIcon from '@mui/icons-material/Download';
import * as yup from "yup";
import RefreshIcon from "@mui/icons-material/Refresh";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

import {
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
} from "@mui/material";
import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import { dateFormatter } from "../../../../helper/helper";
import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Formik, useFormik } from "formik";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
export default function DstReports(props) {
  const id = useParams();

  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [error, seterror] = useState(false);

  const [Status, setStatus] = useState({
    approveType: 1,
    resellerName: null,
    type: null,
    approveAssignedType: null,
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  // .....................................................Formik..........................................................................//
  const initialValues = {
    msisdn: "",
  };

  const validationSchema = yup.object({

    msisdn: yup
      .string()
      .min(8, "Minimum length of a mobile number is 8 digits")
      .max(8, "Maximum length of mobile number is 8 digits")
      .required("Required"),
  });
  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      seterror(false);
      fetchUser(values);
    },
  });
  //......................................................................................................................//
  const customId1 = "custom-id-yes";

  const fetchUser = async (values) => {
    try {
      setOpen(true);

      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/find/dst/in/all-msisdn`,
        {
          msisdn: String("222" + values.msisdn),
          pageNo: Status?.pageNo,
          pageSize: Status?.pageSize,
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          queueId: localStorage.getItem("dstQueCode")?.split(",")?.[1],
          queueCode: localStorage.getItem("dstQueCode")?.split(",")?.[0],
        }
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        setData(res.data?.playsms_tblSMSOutgoing?.content);
        setData1(res.data?.playsms_tblSMSOutgoing);

        setOpen(false);
      } else if (res.data?.statusDescription?.statusCode == 220) {
        setData([]);
        setOpen(false);
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        //   toastId: customId1,
        // });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // ......................................Refresh Btn..........................................................................//
  const RefreshBtn = async (values) => {
    try {
      setOpen(true);

      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/find/48-hour/dst/report/by/queue/code`,
        {
          approvalStatus: Status?.approveType,
          pageNo: Status?.pageNo,
          pageSize: Status?.pageSize,
          queueCode: localStorage.getItem("dstQueCode")?.split(",")?.[0],
          queueId: localStorage.getItem("dstQueCode")?.split(",")?.[1],
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
        }
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        for (
          let index = 0;
          index < res.data.playsms_tblSMSOutgoing?.content?.length;
          index++
        ) {
          res.data.playsms_tblSMSOutgoing.content[index][`Show`] = true;
          // arr.push(obj);
        }
        setData(res.data?.playsms_tblSMSOutgoing?.content);
        setData1(res.data?.playsms_tblSMSOutgoing);
        setOpen(false);
      } else if (res.data?.statusDescription?.statusCode == 220) {
        setData([]);
        setOpen(false);
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // await toast.error(res.data?.statusDescription?.statusMessage, {
        //   theme: "colored",
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // ..............................................................................................................................//
  const fetchUserr = async () => {
    if (Status?.resellerName) {
      try {
        setOpen(true);

        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/find/dst/in/all-msisdn`,
          {
            msisdn: Status?.resellerName,
            pageNo: Status?.pageNo,
            pageSize: Status?.pageSize,
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
            queueId: localStorage.getItem("dstQueCode")?.split(",")?.[1],
            queueCode: localStorage.getItem("dstQueCode")?.split(",")?.[0],
          }
        );

        if (res.data?.statusDescription?.statusCode == 200) {

          for (
            let index = 0;
            index < res.data.dstReport?.content?.length;
            index++
          ) {
            res.data.dstReport.content[index][`Show`] = true;
            // arr.push(obj);
          }

          setData(res.data?.dstReport?.content);
          setData1(res.data?.dstReport);

          setOpen(false);
        } else if (res.data?.statusDescription?.statusCode == 220) {
          setData([]);
          setOpen(false);
          // await toast.error(res.data?.statusDescription?.statusMessage, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          // await toast.error(res.data?.statusDescription?.statusMessage, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
        }
      } catch (error) {
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      try {
        setOpen(true);

        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/campaign-report/v1/find/48-hour/dst/report/by/queue/code`,
          {
            approvalStatus: Status?.approveType,
            pageNo: Status?.pageNo,
            pageSize: Status?.pageSize,
            queueCode: localStorage.getItem("dstQueCode")?.split(",")?.[0],
            queueId: localStorage.getItem("dstQueCode")?.split(",")?.[1],
            role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
          }
        );

        if (res.data?.statusDescription?.statusCode == 200) {
          for (
            let index = 0;
            index < res.data.playsms_tblSMSOutgoing?.content?.length;
            index++
          ) {
            res.data.playsms_tblSMSOutgoing.content[index][`Show`] = true;
            // arr.push(obj);
          }
          setData(res.data?.playsms_tblSMSOutgoing?.content);
          setData1(res.data?.playsms_tblSMSOutgoing);
          setOpen(false);
        } else if (res.data?.statusDescription?.statusCode == 220) {
          setData([]);
          setOpen(false);
          // await toast.error(res.data?.statusDescription?.statusMessage, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          // await toast.error(res.data?.statusDescription?.statusMessage, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };

  useEffect(async () => {
    fetchUserr();
  }, [Status.approveType, Status.pageNo, Status.pageSize, Status.resellerName]);

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell) => {
          // console.log("cell--", cell.row.index);
          return (
            <>
              {cell.row.index +
                1 +
                Status?.pageNo * Status?.pageSize}
            </>
          );
        },
      },
      {
        Header: "Mobile Number",

        accessor: "dst", // accessor is the "key" in the data
      },
      {
        Header: "Sender Id",

        accessor: "psrc", // accessor is the "key" in the data
      },
      // {
      //   Header: "Message",

      //   accessor: "pmsg", // accessor is the "key" in the data
      // },
      // {
      //   Header: "Message",

      //   accessor: "pmsg", // accessor is the "key" in the data

      //   Cell: (cell) => {
      //     return (
      //       <>
      //         <div>{cell.row.original.pmsg}</div>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Message",
        accessor: "pmsg", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.pmsg.length >= 60 ? (
                <span className="d-flex">
                  <div className="showMoreTd">
                    {cell.row.original?.[`Show`]
                      ? cell.row.original.pmsg?.slice(0, 60) + "..."
                      : cell.row.original.pmsg}
                  </div>
                  <button
                    className="showMore"
                    onClick={() => {
                      // Showdata?.[`Show${cell.row.index}`];

                      const dataaa = [...data];
                      dataaa[cell.row.index][`Show`] =
                        !cell.row.original?.[`Show`];

                      setData(dataaa);
                    }}
                  >
                    {cell.row.original?.[`Show`] ? "More" : "Less"}
                  </button>
                </span>
              ) : (
                <>{cell.row.original.pmsg}</>
              )}
            </>
          );
        },
      },
      {
        Header: "Type",

        accessor: "psmsType", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              {cell?.row?.original?.psmsType == "Promotional " ? (
                <div className="">P</div>
              ) : (
                <div className="">T</div>
              )}
            </>
          );
        },
      },
      // {
      //   Header: "Date",

      //   accessor: "pdatetime", // accessor is the "key" in the data
      // },


      {
        Header: "Start Date Time",

        accessor: "pDatetime", // accessor is the "key" in the data
        // Cell: (cell) => {
        //   return <>{dateFormatter(cell.row.original.datetimeScheduled)}</>;
        // },
        // Cell: (cell) => {
        //   return (
        //     <>
        //       <div>{cell?.row?.original?.pdatetime?.split(' ')?.map((dataaa) => {
        //         return (
        //           <>
        //             <span>{dataaa}</span>
        //             <br />
        //           </>
        //         )
        //       })}</div>
        //     </>
        //   );
        // },
      },
      {
        Header: "Status",

        accessor: "log", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.pStatus == 2 ? (
                <div
                  className="badge bg-warning activated_1"
                // style={{ width: "71% !important" }}
                >
                  {/* Message Pushed {"    "} */}
                  {cell?.row?.original?.log}
                </div>
              ) : (
                <div
                  className="badge bg-success activated_1"
                // style={{ width: "71% !important" }}
                >
                  {cell?.row?.original?.log}
                </div>
              )}
            </>
          );
        },
      },
      // {
      //   Header: "Approval Status",

      //   accessor: "approvalStatus", // accessor is the "key" in the data
      // },
    ],
    [Status, data]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };
const location = useLocation()


// console.log("first",location)
useEffect(() => {
  return () => {
    localStorage.removeItem("dstQueCode");
  };
}, []);
  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-4">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <PersonIcon
                style={{
                  color: "white",
                  fontSize: "27px",
                }}
              />            </div>
            <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "6rem" }}>
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                Msisdn Status Report
              </p>
              {/* <button
                                      // disabled={hide}
                                      type="button"
                                      className="btn d-flex btn_icon align-items-center btn_wt_8 bg-gradient-primary m-0 radius d-flex align-items-center"
                                      style={{ width: "auto" }}
                                     onClick={DownloadApi}
                                      // disabled={DownloadDisable}
                                    >
                                      Download
                                      <DownloadIcon/>
                                    </button> */}
{
  location?.pathname != "/dashboard/48HourReport/All" && (<>
    <div className="d-flex gap-4 my-auto ms-4">
                <div className="d-flex my-auto">
                  <label className="mb-0">
                    Campaign Name :
                  </label>
                  &nbsp;
                  <p>
                    {localStorage.getItem("dstQueCode").split(",")[2]}
                  </p>
                </div>
                <div className="d-flex my-auto">
                  <label className="mb-0">

                    Start Date :
                  </label>
                  &nbsp;
                  <p>
                    {localStorage.getItem("dstQueCode").split(",")[3]}
                  </p>
                </div>
                <div className="d-flex my-auto">
                  <label className="mb-0">
                    End Date :
                  </label>
                  &nbsp;
                  <p>
                    {localStorage.getItem("dstQueCode").split(",")[4]}
                  </p>
                </div>
              </div>
  </>)
}

            </div>

          </div>
          <div className="card-body">

            {/* <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 active position-relative"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#AccountDetails"
                  type="button"
                  role="tab"
                  aria-controls="AccountDetails"
                  aria-selected="true"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "1",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Scheduled
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning">
                    {data2?.count?.Scheduled == null
                      ? 0
                      : data2?.count?.Scheduled}
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "2",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Unscheduled
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                    {data2?.admin?.approved == null
                      ? 0
                      : data2?.admin?.approved}
                  </span>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "3",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Pause
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {data2?.admin?.rejected == null
                      ? 0
                      : data2?.admin?.rejected}
                  </span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "4",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Resume
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary">
                    {data2?.client == null ? 0 : data2?.client}
                  </span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link ms-4 position-relative"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    setStatus({
                      ...Status,
                      approveType: "5",
                      approveAssignedType: null,
                    });
                  }}
                >
                  Stopped
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary">
                    {data2?.client == null ? 0 : data2?.client}
                  </span>
                </button>
              </li>
            </ul> */}

            {/* {Status.approveType == "1" && (
              <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link ms-4 position-relative"
                    id="SenderMasking-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#SenderMasking"
                    type="button"
                    role="tab"
                    aria-controls="SenderMasking"
                    aria-selected="false"
                    onClick={() => {
                      setStatus({
                        ...Status,
                        approveAssignedType: "0",
                      });
                    }}
                  >
                    Assigned
                    
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link ms-4 position-relative"
                    id="SenderMasking-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#SenderMasking"
                    type="button"
                    role="tab"
                    aria-controls="SenderMasking"
                    aria-selected="false"
                    onClick={() => {
                      setStatus({
                        ...Status,
                        approveAssignedType: "1",
                      });
                    }}
                  >
                    Not Assigned
                    
                  </button>
                </li>
              </ul>
            )} */}
            {/* <div className="text-end"> */}

            {/* </div> */}


            {data.length > 0 ? (
              <>

                <div className="d-flex justify-content-between my-3" style={{ minHeight: "4rem", maxHeight: "4rem" }}>

                  <div className="my-auto">
                    <div className="d-flex">
                      <div className="my-auto">
                        <select
                          value={Status.pageSize}
                          className="dropdown p-2"
                          onChange={(e) => {
                            setPageSize(Number(e.target.value));
                            setStatus({
                              ...Status,
                              pageSize: e.target.value,
                            });
                          }}
                        >
                          {[10, 25, 50].map((value, i) => {
                            return (
                              <option
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                                value={value}
                                key={value}
                              >
                                Show {value}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="my-auto ms-3">
                        <div className="text-end" style={{ flexGrow: "1" }}>
                          <IconButton
                            variant="text"
                            size="small"
                            sx={{
                              color: "#7B809A",
                            }}
                            onClick={(event) => {
                              setStatus({
                                ...Status,
                                hideShow: !Status.hideShow,
                              });
                            }}
                          >
                            {Status.hideShow ? <CancelIcon /> : <SearchIcon />}
                          </IconButton>
                        </div>
                      </div>

                    </div>

                  </div>

                  <div className="my-auto">
                    <form
                      onSubmit={formik.handleSubmit}
                    >
                      <div className="d-flex flex-wrap justify-content-between my-3">
                        {Status.hideShow && (
                          <>
                            {/* <div className="d-flex"> */}
                            {/* <Autocomplete
                      required
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={data2}
                      sx={{ width: 300 }}
                      //   getOptionLabel={(option) => `${option.eventName}`}
                      // value={Status.resellerName}
                      onChange={(e, val) => {
                        // console.log({ val });
                        setStatus({
                          ...Status,
                          resellerName: val,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          required
                          {...params}
                          label="Select Mobile Number"
                        />
                      )}
                    /> */}

                            <div className="" id="inp_merge">
                              <div className="d-flex me-2 w-100">
                                <input className="inpt_width" disabled value="+222" />
                                <TextField
                                  className="m-0"
                                  style={{
                                    borderRadius: "4px",
                                  }}
                                  // type="number"
                                  type="string"
                                  label="Mobile Number"
                                  name="msisdn"
                                  variant="outlined"
                                  // value={number}
                                  size="small"
                                  required
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title="Mobile Number"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  onChange={formik.handleChange}
                                  value={formik.values.msisdn}
                                  error={
                                    formik.touched.msisdn && Boolean(formik.errors.msisdn)
                                  }
                                  helperText={
                                    formik.touched.msisdn && formik.errors.msisdn
                                  }
                                  onInput={(e) => {
                                    // e.target.value = Math.max(0, parseInt(e.target.value))
                                    //   .toString()
                                    //   .slice(0, 8);
                                    e.target.value = e.target.value.slice(0, 8);
                                  }}
                                  onKeyPress={(event) => {
                                    const keyCode = event.keyCode || event.which;

                                    if (
                                      (keyCode >= 48 && keyCode <= 57) ||
                                      keyCode == 13
                                    ) {
                                      seterror(false);
                                    } else {
                                      event.preventDefault();
                                      seterror(true);
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            {/* </div> */}
                            <div className="d-flex justify-content-between">
                              <div className="my-auto">
                                <button

                                  // onClick={fetchUserr}
                                  className={
                                    Status.type == null &&
                                      (Status.resellerName == null ||
                                        Status.resellerName == "") &&
                                      Status?.startTime == null
                                      ? "btn btn-primary mb-0"
                                      : "btn btn-primary mb-0"
                                  }
                                >
                                  <FilterAltIcon />
                                </button>
                              </div>
                              <div className="my-auto ms-2">
                                <button
                                  type="button"
                                  onClick={() => {
                                    formik.resetForm();
                                  }}
                                  className="btn resetBtn_UP mb-0"
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                          </>
                        )}


                      </div>
                    </form>
                  </div>

                  <div className="my-auto">
                    <Tooltip title="Refresh">
                      <button
                        type="submit"
                        className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                        onClick={RefreshBtn}
                      // onClick={() => RefreshBtn("Text to Copy")}
                      >
                        {/* <i class="material-icons opacity-10">refresh</i> */}
                        <RefreshIcon />
                      </button>
                    </Tooltip>

                  </div>
                </div>


                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}
                </div>

                <div className="table-responsive">
                  <table
                    {...getTableProps()}
                    id="example"
                    className="table table-striped transactional_table trans_table table-bordered dataTable table-sm mt-3"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              // className="text-center width_2"
                              className={
                                column?.Header == "Message"
                                  ? "text-center width_2 update_th messageWidth"
                                  : column?.Header == "Type"
                                    ? "text-center width_2 update_th_sp d-flex"
                                    : "text-center width_2 update_th_sp"
                              }
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? "↑"
                                    : "↓"
                                  : ""}
                              </span>
                              {column.Header == "Type" ? (
                                <>
                                  <InputAdornment
                                    position="end"
                                    className="my-auto"
                                  >
                                    {/* {`(${cell?.row?.original?.username})`} */}
                                    <Tooltip
                                      // title={`Promotional-P ${<br/>} Transactional-T`}
                                      // title={`(${Promotional-P})`<br> `(${Promotional-P})`}
                                      title={"P-Promotional T-Transactional"
                                        .split(" ")
                                        .map((arg) => {
                                          return (
                                            <>
                                              {arg}
                                              <br />
                                            </>
                                          );
                                        })}
                                      id="toolTipId"
                                      placement="top"
                                      arrow
                                      sx={{ color: "white" }}
                                    >
                                      <InfoIcon />
                                    </Tooltip>
                                  </InputAdornment>
                                </>
                              ) : (
                                <></>
                              )}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  // className={
                                  //   cell.column.Header == "Status"
                                  //     ? "text-center"
                                  //     : "text-left"
                                  // }

                                  className={
                                    cell.column.Header == "Mobile Number" ||
                                      cell.column.Header == "Id" ||
                                      cell.column.Header == "Sender Id"
                                      ? "text-end"
                                      : cell.column.Header ==
                                        "Status" ||
                                        cell.column.Header == "Type"
                                        ? "text-center"
                                        : "text-start"
                                  }

                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
                      </strong>
                    </span>
                  </div>

                  {/* <div>
                    <span>
                      Go to Page :
                      <input
                        type="number"
                        // defaultValue={pageIndex + 1}
                        // value={data1?.pageable?.pageNumber + 1}
                        value={Status?.pageNo + 1}
                        onChange={(e) => {
                          if (
                            e.target.value > 0 &&
                            e.target.value < data1?.totalPages + 1
                          ) {
                            const pageNumber = e.target.value
                              ? Number(e.target.value) - 1
                              : 0;
                            setStatus({
                              ...Status,
                              pageNo: pageNumber,
                            });
                          }
                        }}
                        style={{ width: "50px" }}
                      />
                    </span>
                  </div> */}

                  <div>
                    <button
                      className="btn btn_primary "
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo - 1,
                        });
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary ms-2"
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={
                        data1?.totalPages == data1?.pageable?.pageNumber + 1
                      }
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo + 1,
                        });
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center">
                {data?.length == 0 && open ? null : (
                  <div className="text-center mt-4">
                    <h5>No Record Found..!!</h5>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
